var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3630_57908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 8.4C17.6008 8.26551 17.5313 8.14033 17.4167 8.07H17.4146L17.4074 8.066L11.4474 4.53801C11.4217 4.52062 11.395 4.50472 11.3674 4.49041C11.1373 4.37169 10.864 4.37169 10.6338 4.49041C10.6063 4.50473 10.5796 4.52062 10.5538 4.53801L4.59386 8.066L4.58667 8.07C4.40451 8.18328 4.34867 8.42278 4.46194 8.60494C4.49532 8.65861 4.54129 8.70332 4.59586 8.7352L10.5559 12.2632C10.5817 12.2804 10.6084 12.2963 10.6359 12.3108C10.866 12.4295 11.1393 12.4295 11.3695 12.3108C11.3969 12.2963 11.4236 12.2804 11.4495 12.2632L17.4095 8.7352C17.5285 8.66578 17.6012 8.53783 17.5998 8.4Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2887 6.0444H9.1999V9.62959H5.2887V6.0444ZM16.7999 2.4V0.759996C16.8093 0.349958 16.4847 0.00982543 16.0747 0H5.92511C5.51507 0.00982543 5.19051 0.349958 5.19991 0.759996V2.4L11.1999 3.99999L16.7999 2.4Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19971 2.3999H9.1997V5.9999H5.19971V2.3999Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1997 2.3999H9.19971V5.9999L13.1997 9.5999H16.7997V5.9999L13.1997 2.3999Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19971 6H13.1997V9.6H9.19971V6Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19971 9.6001H13.1997V13.2001H9.19971V9.6001Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28857 9.62939H9.19977V12.8886H5.28857V9.62939Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1997 9.6001H16.7997V13.2001H13.1997V9.6001Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 8.7131L17.4091 8.71711L11.4491 12.0691C11.4231 12.0851 11.3967 12.1003 11.3691 12.1139C11.2679 12.1621 11.1579 12.1893 11.0459 12.1939L10.7203 12.0035C10.6928 11.9897 10.6661 11.9743 10.6403 11.9575L4.6003 8.5103H4.5975L4.3999 8.3999V15.1855C4.40298 15.6382 4.77238 16.0028 5.2251 15.9999H16.7875C16.7943 15.9999 16.8003 15.9967 16.8075 15.9967C16.9031 15.9906 16.9974 15.9709 17.0875 15.9383C17.1264 15.9218 17.164 15.9023 17.1999 15.8799C17.2267 15.8647 17.2727 15.8315 17.2727 15.8315C17.4776 15.6799 17.5989 15.4404 17.5999 15.1855V8.3999C17.5997 8.52969 17.5297 8.64936 17.4167 8.7131Z",
    fill: "url(#paint0_linear_3630_57908)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.28 8.37313V8.78913L11.048 13.0799L4.596 8.51313C4.596 8.51092 4.5942 8.50913 4.592 8.50913L4 8.15313V7.85312L4.244 7.84912L4.76 8.14512L4.77199 8.14913L4.81599 8.17713C4.81599 8.17713 10.88 11.6371 10.896 11.6451L11.128 11.7811C11.148 11.7731 11.168 11.7651 11.192 11.7571C11.204 11.7491 17.212 8.36912 17.212 8.36912L17.28 8.37313Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 8.7131L17.4091 8.7175L11.4491 12.0695C11.4231 12.0855 11.3967 12.1007 11.3691 12.1143C11.1376 12.2274 10.8669 12.2274 10.6355 12.1143C10.6081 12.1007 10.5814 12.0858 10.5555 12.0695L4.5955 8.7175L4.5883 8.7131C4.47324 8.65071 4.4011 8.53079 4.3999 8.3999V15.1855C4.40277 15.6381 4.77203 16.0028 5.22467 15.9999C5.22467 15.9999 5.22468 15.9999 5.2247 15.9999H16.7751C17.2277 16.0028 17.597 15.6382 17.5999 15.1855C17.5999 15.1855 17.5999 15.1855 17.5999 15.1855V8.3999C17.5997 8.52969 17.5297 8.64936 17.4167 8.7131Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.5358 12.02L11.4466 12.07C11.4208 12.0865 11.3941 12.1016 11.3666 12.1152C11.2684 12.1635 11.1615 12.1917 11.0522 12.1984L13.3198 14.88L17.2754 15.8332C17.3838 15.7513 17.47 15.6437 17.5262 15.52L11.5358 12.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.9398 11.793L11.4466 12.0702C11.4208 12.0866 11.3941 12.1017 11.3666 12.1154C11.2684 12.1636 11.1615 12.1919 11.0522 12.1986L12.1146 15.1278L17.2766 15.8322C17.48 15.6795 17.5997 15.4401 17.5998 15.1858V15.0982L11.9398 11.793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2359 15.9999H16.7739C16.9514 16.0008 17.1246 15.9447 17.2679 15.8399L10.7199 12.0043C10.6924 11.9905 10.6657 11.9751 10.6399 11.9583L4.5999 8.5111H4.5971L4.3999 8.3999V15.1623C4.39945 15.6244 4.77374 15.9995 5.2359 15.9999C5.23589 15.9999 5.23589 15.9999 5.2359 15.9999Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.9999 3.93339V12.4654C9.99919 12.7645 9.81729 13.0334 9.5399 13.1454C9.45397 13.1823 9.36143 13.2014 9.2679 13.2014H4.3999V3.60019H5.1999V3.2002H9.26791C9.672 3.20173 9.99903 3.52929 9.9999 3.93339Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.5999 4.33333V12.8653C9.60091 12.9619 9.58042 13.0576 9.5399 13.1453C9.42881 13.4191 9.16339 13.5988 8.8679 13.6001H4.3999V3.60013H8.8679C8.98396 3.59897 9.09835 3.62792 9.1999 3.68414C9.4451 3.80767 9.59981 4.05877 9.5999 4.33333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.5999 4.33333V12.0653C9.59795 12.4692 9.27181 12.7966 8.86791 12.8001H4.3999V3.60013H8.8679C8.98396 3.59897 9.09835 3.62792 9.1999 3.68414C9.4451 3.80767 9.59981 4.05877 9.5999 4.33333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.1999 4.33329V12.0653C9.19947 12.4698 8.87244 12.7981 8.4679 12.8001H4.3999V3.6001H8.46789C8.87239 3.60031 9.20011 3.9284 9.19989 4.3329C9.1999 4.33303 9.1999 4.33316 9.1999 4.33329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1331 3.6001H8.46669C8.87163 3.6001 9.19989 3.92837 9.19989 4.33329V11.6669C9.19989 12.0718 8.87163 12.4001 8.46669 12.4001H1.1331C0.728162 12.4001 0.399902 12.0718 0.399902 11.6669V4.33329C0.399902 3.92837 0.728171 3.6001 1.1331 3.6001Z",
    fill: "url(#paint1_linear_3630_57908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69161 6.67537C2.87232 6.29036 3.164 5.96816 3.52922 5.75018C3.93367 5.51862 4.39416 5.40319 4.86002 5.41657C5.29178 5.40721 5.71783 5.51666 6.09162 5.73297C6.44306 5.94255 6.72611 6.24964 6.90641 6.61697C7.10277 7.02173 7.20063 7.46718 7.19202 7.91697C7.20153 8.38704 7.10085 8.85281 6.89802 9.27696C6.71342 9.65742 6.42139 9.97545 6.05802 10.1918C5.66982 10.4147 5.22796 10.527 4.78042 10.5166C4.33943 10.5272 3.90399 10.4165 3.52162 10.1966C3.16713 9.9867 2.88053 9.67927 2.69602 9.31096C2.4985 8.91205 2.39947 8.47161 2.40722 8.02656C2.39899 7.56049 2.49621 7.09859 2.69161 6.67537ZM3.58441 8.84737C3.68076 9.09077 3.84415 9.30186 4.05561 9.45617C4.271 9.60671 4.52891 9.68437 4.79161 9.67777C5.07137 9.68883 5.34713 9.60852 5.57721 9.44896C5.78599 9.29515 5.94509 9.08348 6.03481 8.84016C6.1351 8.56843 6.18459 8.28058 6.18081 7.99097C6.18391 7.69858 6.13738 7.40779 6.0432 7.13097C5.96003 6.88104 5.80606 6.66065 5.60001 6.49657C5.37569 6.32946 5.10068 6.24471 4.8212 6.25657C4.55282 6.24962 4.28913 6.3279 4.06801 6.48017C3.85297 6.63512 3.68648 6.84809 3.58801 7.09417C3.36957 7.65823 3.36843 8.28332 3.58481 8.84817L3.58441 8.84737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1997 2.3999H16.7997V5.9999H13.1997V2.3999Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3630_57908",
    x1: 10.9999,
    y1: 8.3999,
    x2: 10.9999,
    y2: 15.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3630_57908",
    x1: 1.92864,
    y1: 3.02719,
    x2: 7.67116,
    y2: 12.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3630_57908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2,
    height: 16,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/outlook-icon.f0f972e90bd9d8e04f9946ce3ee826f2.svg";
export { ForwardRef as ReactComponent };